(() => {
  const header = document.querySelector('.site-header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 20);
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  const configureDrawer = (drawerSelector, overlaySelector, openSelector, closeSelector) => {
    const drawer = document.querySelector(drawerSelector), overlay = document.querySelector(overlaySelector);
    const opener = document.querySelector(openSelector), closer = document.querySelector(closeSelector);
    if (!drawer || !overlay || !opener) return;
    let previousFocus;
    drawer.inert = true; drawer.setAttribute('aria-hidden', 'true');
    const setOpen = open => {
      if (open) previousFocus = document.activeElement;
      drawer.classList.toggle('is-open', open); overlay.classList.toggle('is-open', open);
      drawer.inert = !open; drawer.setAttribute('aria-hidden', String(!open)); opener.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) closer?.focus(); else previousFocus?.focus();
    };
    opener.addEventListener('click', () => setOpen(true)); closer?.addEventListener('click', () => setOpen(false)); overlay.addEventListener('click', () => setOpen(false));
    drawer.addEventListener('keydown', event => {
      if (event.key === 'Escape') setOpen(false);
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll('a, button, input, select, summary')).filter(el => el.getClientRects().length && !el.disabled);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    window.matchMedia('(min-width:1181px)').addEventListener('change', event => { if(event.matches && drawer.classList.contains('is-open')) setOpen(false); });
  };
  configureDrawer('[data-drawer]', '[data-overlay]', '[data-open-drawer]', '[data-close-drawer]');
  configureDrawer('[data-filter-drawer]', '[data-filter-overlay]', '[data-open-filter]', '[data-close-filter]');
})();
